/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from '@/api'
import type { ApiPaginationResponse, ApiResponse } from '@/api/typings/response.typing'
import type { DiscountCreatePayload, DiscountFilters, DiscountItem } from '@/api/typings/settings.typing'

export interface DiscountUserFilters {
  page?: number
  email?: string
  mobile?: string
  status?: string
  [key: string]: any
}

export interface UnusedDiscountUsersFilters {
  page?: number
  [key: string]: any
}

// DISCOUNTS API
export function getDiscountsAction(filters: DiscountFilters = {}): Promise<ApiPaginationResponse<DiscountItem[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/discounts?${params.toString()}`

  return api.get<ApiPaginationResponse<DiscountItem[]>>(url)
}

export function createDiscountAction(payload: DiscountCreatePayload): Promise<ApiResponse<any>> {
  return api.post<ApiResponse<any>>('/discounts', { ...payload })
}

export function editDiscountAction(
  id: string | number,
  { ...payload }: DiscountCreatePayload
): Promise<ApiResponse<any>> {
  return api.put<ApiResponse<any>>(`/discounts/${id}`, { ...payload })
}

export function getDiscountUsersAction(
  discountId: string | number,
  filters: DiscountUserFilters = {}
): Promise<ApiResponse<any>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/discounts/${discountId}/users?${params.toString()}`

  return api.get<ApiResponse<any>>(url)
}

export function getDiscountDetailsAction(id: string | number): Promise<ApiResponse<any>> {
  return api.get<ApiResponse<any>>(`/discounts/${id}`)
}

export function revokeDiscountFromUser(
  userUuid: string,
  discountCode: string,
  discountUserId: string
): Promise<ApiResponse<any>> {
  const url = `/discounts/users/${userUuid}/revoke/${discountCode}/${discountUserId}`
  return api.post<ApiResponse<any>>(url)
}

export function getUnusedDiscountUsersAction(
  discountCode: string | number,
  filters: UnusedDiscountUsersFilters = {}
): Promise<ApiResponse<any>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/discounts/${discountCode}/unused-users?${params.toString()}`
  return api.get<ApiResponse<any>>(url)
}

export interface PrintDiscountResponse {
  pdf_path: string
}

export function printDiscountUsersAction(discountId: string | number): Promise<PrintDiscountResponse> {
  const url = `/exports/discount/${discountId}/users`
  return api.get<PrintDiscountResponse>(url)
}
